import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Text from "components/Text";
import Link from "components/Link";
import Icon from "components/Icon";
import Button from "components/Button";
import "./style.scss";

function Block({
  title,
  description,
  premiumNotes,
  isPremium,
  padding,
  margin,
  bigPadding,
  collapsable,
  collapsed,
  className,
  children,
}) {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  const showHeader = title || collapsable;
  const classes = classnames("block", className, {
    "block--padding": padding && !bigPadding,
    "block--margin": margin,
    "block--big-padding": bigPadding,
    "block--collapsed": isCollapsed,
    "block--header": showHeader,
  });

  function toggleCollapsed() {
    setIsCollapsed(!isCollapsed);
  }


  return (
    <div className={classes}>
      {showHeader &&
        <div className="block__header">
          {title && <Text size="h3" weight="bold">{title}</Text>}
          {description && <Text color="muted">{description}</Text>}
          {!isPremium && premiumNotes && <Link to="/page/premium"><Text color="premium">{premiumNotes}</Text></Link>}
          {(collapsable && isCollapsed) &&
            <Button style="link" onClick={toggleCollapsed} className="px-2">
              <Icon name="arrowDown" />
            </Button>
          }
        </div>
      }

      <div className="block__content">
        {children}
      </div>
    </div>
  );
}

Block.defaultProps = {
  collapsable: false,
  collapsed: false,
  margin: true,
  padding: true,
  bigPadding: false,
  title: null,
  description: null,
  premiumNotes: null,
  isPremium: false,
};

Block.propTypes = {
  collapsable: PropTypes.bool,
  collapsed: PropTypes.bool,
  padding: PropTypes.bool,
  margin: PropTypes.bool,
  bigPadding: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.string,
  premiumNotes: PropTypes.string,
  isPremium: PropTypes.bool,
};

export default Block;
